import React, { useState, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import * as Icons from "react-icons/fa";
import logors from "../../assets/logo_rs.png";

// Hapus 'user' dari props karena tidak lagi diperlukan untuk fetching
const AppSidebar = ({ collapsed, isMobile, onCloseMobile, menus }) => {
  const [openMenus, setOpenMenus] = useState({});
  const location = useLocation();

  // Hapus useEffect untuk fetching data menu

  const toggleMenu = (idMenu) => {
    setOpenMenus((prev) => ({ ...prev, [idMenu]: !prev[idMenu] }));
  };

  const renderIcon = (iconName) => {
    const Icon = Icons[iconName];
    return Icon ? <Icon className="inline-block" /> : null;
  };

  const renderMenu = (menuList) =>
    menuList.map((menu) => {
      const isActive = menu.path && location.pathname === menu.path;
      const hasChildren = menu.children && menu.children.length > 0;
      const isOpen = openMenus[menu.idMenu];

      const menuContent = (
        <div className="flex items-center gap-2">
          {renderIcon(menu.icon)}
          {!collapsed && <span>{menu.title}</span>}
        </div>
      );

      return (
        <div key={menu.idMenu} className="mb-1 relative group">
          {menu.path ? (
            <Link
              to={menu.path}
              onClick={isMobile ? onCloseMobile : undefined}
              className={`flex items-center justify-between gap-2 p-2 rounded-md transition-colors ${
                isActive
                  ? "bg-blue-500 text-white"
                  : "hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200"
              }`}
            >
              {menuContent}
              {!collapsed && hasChildren && <span>{isOpen ? "▾" : "▸"}</span>}
            </Link>
          ) : (
            <button
              onClick={() => toggleMenu(menu.idMenu)}
              className={`flex items-center justify-between w-full p-2 rounded-md transition-colors ${
                isActive
                  ? "bg-blue-500 text-white"
                  : "hover:bg-gray-200 dark:hover:bg-gray-700 text-gray-700 dark:text-gray-200 font-semibold"
              }`}
            >
              {menuContent}
              {!collapsed && hasChildren && <span>{isOpen ? "▾" : "▸"}</span>}
            </button>
          )}

          {collapsed && (
            <span className="absolute left-full top-1/2 -translate-y-1/2 ml-2 px-2 py-1 rounded-md bg-gray-800 text-white text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity z-50">
              {menu.title}
            </span>
          )}

          {hasChildren && (
            <div
              className={`ml-4 overflow-hidden transition-all duration-300 ${
                isOpen ? "max-h-96" : "max-h-0"
              }`}
            >
              {renderMenu(menu.children)}
            </div>
          )}
        </div>
      );
    });

  return (
    <>
      {isMobile && !collapsed && (
        <div
          className="fixed inset-0 bg-black opacity-50 z-10"
          onClick={onCloseMobile}
        ></div>
      )}

      <div
        className={`fixed lg:relative z-20 h-full overflow-y-auto bg-gray-100 dark:bg-gray-900 transition-all duration-300 ${
          collapsed ? "w-16" : "w-64"
        }`}
      >
        <div className="flex items-center gap-2 p-4 border-b border-gray-300 dark:border-gray-700">
          <img
            src={logors}
            alt="Logo"
            className={`h-14 w-26 transition-all duration-300 ${
              collapsed ? "mx-auto" : ""
            }`}
          />
        </div>

        <div className="p-2">{renderMenu(menus)}</div>
      </div>
    </>
  );
};

export default AppSidebar;
